import axiosInstance from "../../api/axiosInstance";
// MSEDCL requests are encrypted centrally by axiosInstance.
import {
  getMsedclCaForm,
  getMsedclCustomerAccounts,
  getMsedclUpdateSessionVariable,
  getMsedclComplaintTypes,
  getMsedclSubmitComplaint,
  getMsedclComplaintStatusCheck,
  getMsedclConsumerDetails,
  getMsedclDeactivateSubscription,
  getMsedclGogreenStatus,
  getMsedclGogreenSubscribe,
  getMsedclGogreenSubscribeWithEmail,
  getMsedclGogreenUnsubscribe,
  getMsedclTrackingApplications,
  getMsedclGetApplicationById,
  getMsedclMtskpyApplicationStatus,
  getMsedclServiceRequestDetails,
  getMsedclConsumerClosureFeedbackDetails,
  getMsedclConsumerClosureSubmitFeedback,
  getMsedclChangeAddressDistrictList,
  getMsedclChangeAddressTalukaList,
  getMsedclChangeAddressVillageList,
  getMsedclChangeAddressPincodeList,
  getMsedclChangeAddressSubmit,
  getMsedclTariffActivityTypeList,
  getMsedclTariffActivityGroupList,
  getMsedclTariffActivityList,
  getMsedclSubmitTariffChange,
  getMsedclGenerateAadhaarOtp,
  getMsedclVerifyAadhaarOtp,
  getMsedclStoreUid,
  getMsedclContactDetailsUpdate,
  getMsedclConsumerNameByConsumerNo,
  getMsedclSubmitChangeOfName,
  getMsedclChangeOfNameReasonList,
  getMsedclMainDocuments,
  getMsedclSubDocuments,
  getMsedclGetSalarySlip,
  getMsedclGetBiometricAttendance,
  getMsedclFundContributionDetail,
  getMsedclFundContributionMasterData,
  getMsedclSaveFundContributionDetail,
  getMsedclGetEmployeeDetailsByMobile,
  getMsedclLeaveTypeList,
  getMsedclLeaveBalance,
  getMsedclLeaveCodeBalance,
  getMsedclLeaveApplicationSubmit,
  getMsedclLeaveApplicationSave,
  getMsedclLeaveDisabilityTypes,
  getMsedclLeaveApplicationList,
  getMsedclLtcBlockYear,
  getMsedclUpdateProfile,
  getMsedclEmployeePortalFileUpload,
  getMsedclEmployeePortalFileList,
  getMsedclEmployeePortalFileDelete,
  getMsedclEmployeePortalFileDownload,
  getMsedclCheckOverlappingClaims,
  getMsedclCheckOverlappingSavings,
  getMsedclSubmitClaimApplication,
  getMsedclClaimApplicationList,
  getMsedclNewClaimApplication,
  getMsedclViewClaimApplication,
  getMsedclMobileLimit,
  getMsedclNewExtraCpfApplication,
  getMsedclExtraCpfApplicationList,
  getMsedclSaveExtraCpfApplication,
  getMsedclNewRegimeApplication,
  getMsedclSaveRegimeApplication,
  getMsedclClaimFileOptions,
  getMsedclClaimClassOptions,
  getMsedclDaTypes,
  getMsedclDaRate,
  getMsedclSaveClaimPassengerDetails,
  getMsedclTimeSlotOptions,
} from "../../utills/constants";

// ==================== CA Form ====================
export const MSEDCL_CA_FORM_REQUEST = "MSEDCL_CA_FORM_REQUEST";
export const MSEDCL_CA_FORM_SUCCESS = "MSEDCL_CA_FORM_SUCCESS";
export const MSEDCL_CA_FORM_FAILURE = "MSEDCL_CA_FORM_FAILURE";

export const msedclCaFormRequest = () => ({ type: MSEDCL_CA_FORM_REQUEST });
export const msedclCaFormSuccess = (data) => ({ type: MSEDCL_CA_FORM_SUCCESS, payload: data });
export const msedclCaFormFailure = (error) => ({ type: MSEDCL_CA_FORM_FAILURE, payload: error });

export const msedclGetCaForm = (payload) => async (dispatch) => {
  dispatch(msedclCaFormRequest());

  try {
    const response = await axiosInstance.post(getMsedclCaForm(), payload);

    if (!response?.data) throw new Error("No CA form data found.");

    dispatch(msedclCaFormSuccess(response.data));
  } catch (error) {
    console.error("Error fetching CA form:", error);
    dispatch(
      msedclCaFormFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

/** Save CA number (POST) - used on Home Continue. Payload: flow_id, phone_number, SelectedConsumerNumber. */
export const msedclSaveCaNumber = (payload) => async (dispatch) => {
  dispatch(msedclCaFormRequest());
  try {
    const body = {
      flow_id: String(payload.flow_id ?? ""),
      phone_number: String(payload.phone_number ?? ""),
      SelectedConsumerNumber: String(payload.SelectedConsumerNumber ?? "").trim(),
    };
    const response = await axiosInstance.post(getMsedclCaForm(), body);
    if (!response?.data) throw new Error("No response from save CA number.");
    dispatch(msedclCaFormSuccess(response.data));
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    dispatch(msedclCaFormFailure(message));
    throw new Error(message);
  }
};

// ==================== Complaint Types ====================
export const MSEDCL_FETCH_COMPLAINT_TYPES_REQUEST = "MSEDCL_FETCH_COMPLAINT_TYPES_REQUEST";
export const MSEDCL_FETCH_COMPLAINT_TYPES_SUCCESS = "MSEDCL_FETCH_COMPLAINT_TYPES_SUCCESS";
export const MSEDCL_FETCH_COMPLAINT_TYPES_FAILURE = "MSEDCL_FETCH_COMPLAINT_TYPES_FAILURE";

export const msedclFetchComplaintTypesRequest = () => ({ type: MSEDCL_FETCH_COMPLAINT_TYPES_REQUEST });
export const msedclFetchComplaintTypesSuccess = (data) => ({ type: MSEDCL_FETCH_COMPLAINT_TYPES_SUCCESS, payload: data });
export const msedclFetchComplaintTypesFailure = (error) => ({ type: MSEDCL_FETCH_COMPLAINT_TYPES_FAILURE, payload: error });

export const msedclGetComplaintTypes = (mode, consumerNumber, majorTypeId = null, requestTypeId = null) => async (dispatch) => {
  dispatch(msedclFetchComplaintTypesRequest());
  try {
    const payload = {
      consumer_number: consumerNumber,
    };
    if (mode !== "major_type") {
      payload.mode = mode;
    }
    
    // Add major_type_id for request_type mode
    if (mode === "request_type" && majorTypeId) {
      payload["major_type_id"] = majorTypeId;
    }
    
    // Add major_type_id and request_type_id for sub_request_type mode
    if (mode === "sub_request_type" && majorTypeId && requestTypeId) {
      payload["major_type_id"] = majorTypeId;
      payload["request_type_id"] = requestTypeId;
    }

    const categoryType = mode === "request_type" ? majorTypeId : mode === "sub_request_type" ? requestTypeId : null;
    const requestConfig = categoryType ? { headers: { category_type: String(categoryType) } } : {};
    const response = await axiosInstance.post(getMsedclComplaintTypes(mode), payload, requestConfig);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch complaint types");
    }
    dispatch(msedclFetchComplaintTypesSuccess({ mode, data: response.data.data, majorTypeId, requestTypeId }));
  } catch (error) {
    console.error("Error fetching complaint types:", error);
    dispatch(
      msedclFetchComplaintTypesFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Register Complain ====================
export const MSEDCL_REGISTER_COMPLAIN_REQUEST = "MSEDCL_REGISTER_COMPLAIN_REQUEST";
export const MSEDCL_REGISTER_COMPLAIN_SUCCESS = "MSEDCL_REGISTER_COMPLAIN_SUCCESS";
export const MSEDCL_REGISTER_COMPLAIN_FAILURE = "MSEDCL_REGISTER_COMPLAIN_FAILURE";

export const msedclRegisterComplainRequest = () => ({ type: MSEDCL_REGISTER_COMPLAIN_REQUEST });
export const msedclRegisterComplainSuccess = (data) => ({ type: MSEDCL_REGISTER_COMPLAIN_SUCCESS, payload: data });
export const msedclRegisterComplainFailure = (error) => ({ type: MSEDCL_REGISTER_COMPLAIN_FAILURE, payload: error });

export const msedclRegisterComplain = (payload) => async (dispatch) => {
  dispatch(msedclRegisterComplainRequest());

  try {
    const categoryType = payload?.category_type ?? payload?.request_type_id ?? "";
    const headers = {};
    if (categoryType) headers["category_type"] = String(categoryType);

    const response = await axiosInstance.post(
      getMsedclSubmitComplaint(),
      payload,
      Object.keys(headers).length ? { headers } : {}
    );

    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Complaint registration failed.");
    }

    dispatch(msedclRegisterComplainSuccess(response.data));
  } catch (error) {
    console.error("Error registering complaint:", error);
    dispatch(
      msedclRegisterComplainFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Payment ====================
export const MSEDCL_INIT_PAYMENT_REQUEST = "MSEDCL_INIT_PAYMENT_REQUEST";
export const MSEDCL_INIT_PAYMENT_SUCCESS = "MSEDCL_INIT_PAYMENT_SUCCESS";
export const MSEDCL_INIT_PAYMENT_FAILURE = "MSEDCL_INIT_PAYMENT_FAILURE";

export const msedclInitPaymentRequest = () => ({ type: MSEDCL_INIT_PAYMENT_REQUEST });
export const msedclInitPaymentSuccess = (data) => ({ type: MSEDCL_INIT_PAYMENT_SUCCESS, payload: data });
export const msedclInitPaymentFailure = (error) => ({ type: MSEDCL_INIT_PAYMENT_FAILURE, payload: error });

export const msedclInitializePayment = (payload) => async (dispatch) => {
  dispatch(msedclInitPaymentRequest());

  try {
    const response = await axiosInstance.post(
      getMsedclCaForm(), // Replace with actual endpoint
      payload
    );

    if (!response?.data) throw new Error("Payment initialization failed.");

    dispatch(msedclInitPaymentSuccess(response.data));
  } catch (error) {
    console.error("Payment initialization error:", error);
    dispatch(
      msedclInitPaymentFailure(
        error.response?.data?.message || error.message || "Payment failed"
      )
    );
  }
};

// ==================== Track Complaint Status ====================
export const MSEDCL_TRACK_COMPLAINT_STATUS_REQUEST = "MSEDCL_TRACK_COMPLAINT_STATUS_REQUEST";
export const MSEDCL_TRACK_COMPLAINT_STATUS_SUCCESS = "MSEDCL_TRACK_COMPLAINT_STATUS_SUCCESS";
export const MSEDCL_TRACK_COMPLAINT_STATUS_FAILURE = "MSEDCL_TRACK_COMPLAINT_STATUS_FAILURE";

export const msedclTrackComplaintStatusRequest = () => ({ type: MSEDCL_TRACK_COMPLAINT_STATUS_REQUEST });
export const msedclTrackComplaintStatusSuccess = (data) => ({ type: MSEDCL_TRACK_COMPLAINT_STATUS_SUCCESS, payload: data });
export const msedclTrackComplaintStatusFailure = (error) => ({ type: MSEDCL_TRACK_COMPLAINT_STATUS_FAILURE, payload: error });

export const msedclTrackComplaintStatus = (serviceRequestId) => async (dispatch) => {
  dispatch(msedclTrackComplaintStatusRequest());

  try {
    const payload = {
      service_request_id: serviceRequestId,
    };

    const response = await axiosInstance.post(
      getMsedclComplaintStatusCheck(),
      payload
    );

    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch complaint status");
    }

    dispatch(msedclTrackComplaintStatusSuccess(response.data));
  } catch (error) {
    console.error("Error tracking complaint status:", error);
    dispatch(
      msedclTrackComplaintStatusFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Go Green Status (subscribe / unsubscribe details on page load) ====================
export const MSEDCL_GOGREEN_STATUS_REQUEST = "MSEDCL_GOGREEN_STATUS_REQUEST";
export const MSEDCL_GOGREEN_STATUS_SUCCESS = "MSEDCL_GOGREEN_STATUS_SUCCESS";
export const MSEDCL_GOGREEN_STATUS_FAILURE = "MSEDCL_GOGREEN_STATUS_FAILURE";

export const msedclGogreenStatusRequest = () => ({ type: MSEDCL_GOGREEN_STATUS_REQUEST });
export const msedclGogreenStatusSuccess = (data) => ({ type: MSEDCL_GOGREEN_STATUS_SUCCESS, payload: data });
export const msedclGogreenStatusFailure = (error) => ({ type: MSEDCL_GOGREEN_STATUS_FAILURE, payload: error });

export const msedclGetGogreenStatus = (consumerNumbers) => async (dispatch) => {
  dispatch(msedclGogreenStatusRequest());
  try {
    const payload = { consumer_numbers: Array.isArray(consumerNumbers) ? consumerNumbers : [consumerNumbers] };
    const response = await axiosInstance.post(getMsedclGogreenStatus(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch Go Green status");
    }
    dispatch(msedclGogreenStatusSuccess(response.data));
  } catch (error) {
    console.error("Error fetching Go Green status:", error);
    dispatch(
      msedclGogreenStatusFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Go Green Subscribe (on Activate click) ====================
export const MSEDCL_GOGREEN_SUBSCRIBE_REQUEST = "MSEDCL_GOGREEN_SUBSCRIBE_REQUEST";
export const MSEDCL_GOGREEN_SUBSCRIBE_SUCCESS = "MSEDCL_GOGREEN_SUBSCRIBE_SUCCESS";
export const MSEDCL_GOGREEN_SUBSCRIBE_FAILURE = "MSEDCL_GOGREEN_SUBSCRIBE_FAILURE";

export const msedclGogreenSubscribeRequest = () => ({ type: MSEDCL_GOGREEN_SUBSCRIBE_REQUEST });
export const msedclGogreenSubscribeSuccess = (data) => ({ type: MSEDCL_GOGREEN_SUBSCRIBE_SUCCESS, payload: data });
export const msedclGogreenSubscribeFailure = (error) => ({ type: MSEDCL_GOGREEN_SUBSCRIBE_FAILURE, payload: error });

export const msedclGogreenSubscribe = (consumerNumbers) => async (dispatch) => {
  dispatch(msedclGogreenSubscribeRequest());
  try {
    const payload = { consumer_numbers: Array.isArray(consumerNumbers) ? consumerNumbers : [consumerNumbers] };
    const response = await axiosInstance.post(getMsedclGogreenSubscribe(), payload);
    if (!response?.data || response.data.status !== "success") {
      const msg = response.data?.message || "Failed to subscribe";
      dispatch(msedclGogreenSubscribeFailure(msg));
      throw new Error(msg);
    }
    dispatch(msedclGogreenSubscribeSuccess(response.data));
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    if (error.message !== message) {
      dispatch(msedclGogreenSubscribeFailure(message));
    }
    throw error;
  }
};

// ==================== Go Green Subscribe With Email (when subscriptionPosssibleWithEmail) ====================
export const msedclGogreenSubscribeWithEmail = (consumers) => async (dispatch) => {
  dispatch(msedclGogreenSubscribeRequest());
  try {
    const consumersList = Array.isArray(consumers) ? consumers : [consumers];
    const payload = { consumers: consumersList };
    const response = await axiosInstance.post(getMsedclGogreenSubscribeWithEmail(), payload, {
      headers: {
        consumers: JSON.stringify(consumersList),
      },
    });
    if (!response?.data || response.data.status !== "success") {
      const msg = response.data?.message || "Failed to subscribe";
      dispatch(msedclGogreenSubscribeFailure(msg));
      throw new Error(msg);
    }
    dispatch(msedclGogreenSubscribeSuccess(response.data));
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    if (error.message !== message) {
      dispatch(msedclGogreenSubscribeFailure(message));
    }
    throw error;
  }
};

// ==================== Go Green Unsubscribe (on Unsubscribe click) ====================
export const MSEDCL_GOGREEN_UNSUBSCRIBE_REQUEST = "MSEDCL_GOGREEN_UNSUBSCRIBE_REQUEST";
export const MSEDCL_GOGREEN_UNSUBSCRIBE_SUCCESS = "MSEDCL_GOGREEN_UNSUBSCRIBE_SUCCESS";
export const MSEDCL_GOGREEN_UNSUBSCRIBE_FAILURE = "MSEDCL_GOGREEN_UNSUBSCRIBE_FAILURE";

export const msedclGogreenUnsubscribeRequest = () => ({ type: MSEDCL_GOGREEN_UNSUBSCRIBE_REQUEST });
export const msedclGogreenUnsubscribeSuccess = (data) => ({ type: MSEDCL_GOGREEN_UNSUBSCRIBE_SUCCESS, payload: data });
export const msedclGogreenUnsubscribeFailure = (error) => ({ type: MSEDCL_GOGREEN_UNSUBSCRIBE_FAILURE, payload: error });

export const msedclGogreenUnsubscribe = (consumerNumbers) => async (dispatch) => {
  dispatch(msedclGogreenUnsubscribeRequest());
  try {
    const payload = { consumer_numbers: Array.isArray(consumerNumbers) ? consumerNumbers : [consumerNumbers] };
    const response = await axiosInstance.post(getMsedclGogreenUnsubscribe(), payload);
    if (!response?.data || response.data.status !== "success") {
      const msg = response.data?.message || "Failed to unsubscribe";
      dispatch(msedclGogreenUnsubscribeFailure(msg));
      throw new Error(msg);
    }
    dispatch(msedclGogreenUnsubscribeSuccess(response.data));
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    if (error.message !== message) {
      dispatch(msedclGogreenUnsubscribeFailure(message));
    }
    throw error;
  }
};

// ==================== Consumer Details (for email unsubscription) ====================
export const MSEDCL_CONSUMER_DETAILS_REQUEST = "MSEDCL_CONSUMER_DETAILS_REQUEST";
export const MSEDCL_CONSUMER_DETAILS_SUCCESS = "MSEDCL_CONSUMER_DETAILS_SUCCESS";
export const MSEDCL_CONSUMER_DETAILS_FAILURE = "MSEDCL_CONSUMER_DETAILS_FAILURE";

export const msedclConsumerDetailsRequest = () => ({ type: MSEDCL_CONSUMER_DETAILS_REQUEST });
export const msedclConsumerDetailsSuccess = (data) => ({ type: MSEDCL_CONSUMER_DETAILS_SUCCESS, payload: data });
export const msedclConsumerDetailsFailure = (error) => ({ type: MSEDCL_CONSUMER_DETAILS_FAILURE, payload: error });

export const msedclGetConsumerDetails = (consumerNumber) => async (dispatch) => {
  dispatch(msedclConsumerDetailsRequest());
  try {
    const payload = { consumer_number: consumerNumber };
    const response = await axiosInstance.post(getMsedclConsumerDetails(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch consumer details");
    }
    dispatch(msedclConsumerDetailsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching consumer details:", error);
    dispatch(
      msedclConsumerDetailsFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Deactivate Email Subscription ====================
export const MSEDCL_DEACTIVATE_SUBSCRIPTION_REQUEST = "MSEDCL_DEACTIVATE_SUBSCRIPTION_REQUEST";
export const MSEDCL_DEACTIVATE_SUBSCRIPTION_SUCCESS = "MSEDCL_DEACTIVATE_SUBSCRIPTION_SUCCESS";
export const MSEDCL_DEACTIVATE_SUBSCRIPTION_FAILURE = "MSEDCL_DEACTIVATE_SUBSCRIPTION_FAILURE";

export const msedclDeactivateSubscriptionRequest = () => ({ type: MSEDCL_DEACTIVATE_SUBSCRIPTION_REQUEST });
export const msedclDeactivateSubscriptionSuccess = (data) => ({ type: MSEDCL_DEACTIVATE_SUBSCRIPTION_SUCCESS, payload: data });
export const msedclDeactivateSubscriptionFailure = (error) => ({ type: MSEDCL_DEACTIVATE_SUBSCRIPTION_FAILURE, payload: error });

export const msedclDeactivateSubscription = (payload) => async (dispatch) => {
  dispatch(msedclDeactivateSubscriptionRequest());
  try {
    const response = await axiosInstance.post(getMsedclDeactivateSubscription(), payload);
    if (!response?.data || response.data.status !== "success") {
      const msg = response.data?.message || "Failed to deactivate subscription";
      dispatch(msedclDeactivateSubscriptionFailure(msg));
      throw new Error(msg);
    }
    dispatch(msedclDeactivateSubscriptionSuccess(response.data));
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    if (error.message !== message) {
      dispatch(msedclDeactivateSubscriptionFailure(message));
    }
    throw error;
  }
};

// ==================== Track Your Application - Application List (dropdown) ====================
export const MSEDCL_TRACKING_APPLICATIONS_REQUEST = "MSEDCL_TRACKING_APPLICATIONS_REQUEST";
export const MSEDCL_TRACKING_APPLICATIONS_SUCCESS = "MSEDCL_TRACKING_APPLICATIONS_SUCCESS";
export const MSEDCL_TRACKING_APPLICATIONS_FAILURE = "MSEDCL_TRACKING_APPLICATIONS_FAILURE";

export const msedclTrackingApplicationsRequest = () => ({ type: MSEDCL_TRACKING_APPLICATIONS_REQUEST });
export const msedclTrackingApplicationsSuccess = (data) => ({ type: MSEDCL_TRACKING_APPLICATIONS_SUCCESS, payload: data });
export const msedclTrackingApplicationsFailure = (error) => ({ type: MSEDCL_TRACKING_APPLICATIONS_FAILURE, payload: error });

export const msedclGetTrackingApplications = () => async (dispatch) => {
  dispatch(msedclTrackingApplicationsRequest());
  try {
    const response = await axiosInstance.get(getMsedclTrackingApplications());
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch application list");
    }
    dispatch(msedclTrackingApplicationsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching tracking applications:", error);
    dispatch(
      msedclTrackingApplicationsFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Customer Accounts (Home - list CA numbers) ====================
export const MSEDCL_CUSTOMER_ACCOUNTS_REQUEST = "MSEDCL_CUSTOMER_ACCOUNTS_REQUEST";
export const MSEDCL_CUSTOMER_ACCOUNTS_SUCCESS = "MSEDCL_CUSTOMER_ACCOUNTS_SUCCESS";
export const MSEDCL_CUSTOMER_ACCOUNTS_FAILURE = "MSEDCL_CUSTOMER_ACCOUNTS_FAILURE";

export const msedclCustomerAccountsRequest = () => ({ type: MSEDCL_CUSTOMER_ACCOUNTS_REQUEST });
export const msedclCustomerAccountsSuccess = (data) => ({ type: MSEDCL_CUSTOMER_ACCOUNTS_SUCCESS, payload: data });
export const msedclCustomerAccountsFailure = (error) => ({ type: MSEDCL_CUSTOMER_ACCOUNTS_FAILURE, payload: error });

const NO_CUSTOMER_ACCOUNTS_KEY = "could not find any customer accounts";

export const msedclGetCustomerAccounts = () => async (dispatch) => {
  dispatch(msedclCustomerAccountsRequest());
  try {
    const response = await axiosInstance.get(getMsedclCustomerAccounts());
    const data = response?.data;
    const message = data?.message || "";
    const isNoAccountsMessage = message.trim().toLowerCase().includes(NO_CUSTOMER_ACCOUNTS_KEY);
    if (!data) {
      throw new Error("Failed to fetch customer accounts");
    }
    const payload = data?.data != null ? data.data : data;
    const hasConsumers = Array.isArray(payload?.consumers_numbers);
    if (data.status === "success" || Array.isArray(data.consumers_numbers) || hasConsumers) {
      const toReturn = hasConsumers ? payload : data;
      dispatch(msedclCustomerAccountsSuccess(toReturn));
      return toReturn;
    }
    if (isNoAccountsMessage) {
      const emptyData = { consumers_numbers: [], total_account_count: "0", view_more_link: "" };
      dispatch(msedclCustomerAccountsSuccess(emptyData));
      return emptyData;
    }
    throw new Error(message || "Failed to fetch customer accounts");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    const isNoAccountsMessage = String(message).trim().toLowerCase().includes(NO_CUSTOMER_ACCOUNTS_KEY);
    if (isNoAccountsMessage) {
      const emptyData = { consumers_numbers: [], total_account_count: "0", view_more_link: "" };
      dispatch(msedclCustomerAccountsSuccess(emptyData));
      return emptyData;
    }
    console.error("Error fetching customer accounts:", error);
    dispatch(msedclCustomerAccountsFailure(message));
    throw new Error(message);
  }
};

// ==================== Update Session Variable (checkbox on Home) ====================
export const msedclUpdateSessionVariable = (payload) => async (dispatch) => {
  try {
    const body = {
      flow_id: String(payload.flow_id ?? ""),
      phone_number: String(payload.phone_number ?? ""),
      SelectedConsumerNumber: String(payload.SelectedConsumerNumber ?? ""),
      ...(payload.checksum != null && payload.checksum !== "" && { checksum: String(payload.checksum) }),
    };
    const response = await axiosInstance.post(getMsedclUpdateSessionVariable(), body);
    if (!response?.data) throw new Error("No response from update session variable");
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error updating session variable:", error);
    throw new Error(message);
  }
};

// ==================== Get Application By ID (Track Your Application details) ====================
export const MSEDCL_GET_APPLICATION_BY_ID_REQUEST = "MSEDCL_GET_APPLICATION_BY_ID_REQUEST";
export const MSEDCL_GET_APPLICATION_BY_ID_SUCCESS = "MSEDCL_GET_APPLICATION_BY_ID_SUCCESS";
export const MSEDCL_GET_APPLICATION_BY_ID_FAILURE = "MSEDCL_GET_APPLICATION_BY_ID_FAILURE";

export const msedclGetApplicationByIdRequest = () => ({ type: MSEDCL_GET_APPLICATION_BY_ID_REQUEST });
export const msedclGetApplicationByIdSuccess = (data) => ({ type: MSEDCL_GET_APPLICATION_BY_ID_SUCCESS, payload: data });
export const msedclGetApplicationByIdFailure = (error) => ({ type: MSEDCL_GET_APPLICATION_BY_ID_FAILURE, payload: error });

export const msedclGetApplicationById = (applicationId, consumerNo) => async (dispatch) => {
  dispatch(msedclGetApplicationByIdRequest());
  try {
    const payload = {
      id: String(applicationId),
      ...(consumerNo != null && consumerNo !== "" && { consumer_no: String(consumerNo) }),
    };
    const response = await axiosInstance.post(getMsedclGetApplicationById(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch application details");
    }
    dispatch(msedclGetApplicationByIdSuccess(response.data));
  } catch (error) {
    console.error("Error fetching application by id:", error);
    dispatch(
      msedclGetApplicationByIdFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Get Sub Documents (change of name / mobile update) ====================
export const msedclGetSubDocuments = (payload) => async (dispatch) => {
  try {
    const body = {
      consumer_number: String(payload.consumer_number),
      reason_id: String(payload.reason_id),
      doc_id: String(payload.doc_id),
    };
    const response = await axiosInstance.post(getMsedclSubDocuments(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch sub-documents");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error fetching sub-documents:", error);
    throw new Error(message);
  }
};

// ==================== Get Main Documents ====================
export const msedclGetMainDocuments = (payload) => async (dispatch) => {
  try {
    const body = {
      consumer_number: String(payload.consumer_number || ""),
      reason_id: String(payload.reason_id || ""),
    };
    const response = await axiosInstance.post(getMsedclMainDocuments(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch main documents");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error fetching main documents:", error);
    throw new Error(message);
  }
};

export const clearMsedclApplicationByIdData = () => ({ type: "CLEAR_MSEDCL_APPLICATION_BY_ID_DATA" });

// ==================== MTSKPY Application Status (when application id is 10) ====================
export const msedclGetMtskpyApplicationStatus = (applicationId) => async (dispatch) => {
  dispatch(msedclGetApplicationByIdRequest());
  try {
    const payload = { application_id: String(applicationId) };
    const response = await axiosInstance.post(getMsedclMtskpyApplicationStatus(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch application status");
    }
    dispatch(msedclGetApplicationByIdSuccess(response.data));
  } catch (error) {
    dispatch(
      msedclGetApplicationByIdFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Service Request Details (list for Track Complaint Status) ====================
export const MSEDCL_SERVICE_REQUEST_DETAILS_REQUEST = "MSEDCL_SERVICE_REQUEST_DETAILS_REQUEST";
export const MSEDCL_SERVICE_REQUEST_DETAILS_SUCCESS = "MSEDCL_SERVICE_REQUEST_DETAILS_SUCCESS";
export const MSEDCL_SERVICE_REQUEST_DETAILS_FAILURE = "MSEDCL_SERVICE_REQUEST_DETAILS_FAILURE";

export const msedclServiceRequestDetailsRequest = () => ({ type: MSEDCL_SERVICE_REQUEST_DETAILS_REQUEST });
export const msedclServiceRequestDetailsSuccess = (data) => ({ type: MSEDCL_SERVICE_REQUEST_DETAILS_SUCCESS, payload: data });
export const msedclServiceRequestDetailsFailure = (error) => ({ type: MSEDCL_SERVICE_REQUEST_DETAILS_FAILURE, payload: error });

export const msedclGetServiceRequestDetails = (consumerNumber, numberOfRecords = 5) => async (dispatch) => {
  dispatch(msedclServiceRequestDetailsRequest());
  try {
    const payload = {
      consumer_number: String(consumerNumber).trim(),
      number_of_records: numberOfRecords,
    };
    const response = await axiosInstance.post(getMsedclServiceRequestDetails(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch service requests");
    }
    dispatch(msedclServiceRequestDetailsSuccess(response.data));
  } catch (error) {
    console.error("Error fetching service request details:", error);
    dispatch(
      msedclServiceRequestDetailsFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Consumer Closure Feedback Details (Unresolved Reason options) ====================
export const MSEDCL_FEEDBACK_DETAILS_REQUEST = "MSEDCL_FEEDBACK_DETAILS_REQUEST";
export const MSEDCL_FEEDBACK_DETAILS_SUCCESS = "MSEDCL_FEEDBACK_DETAILS_SUCCESS";
export const MSEDCL_FEEDBACK_DETAILS_FAILURE = "MSEDCL_FEEDBACK_DETAILS_FAILURE";

export const msedclFeedbackDetailsRequest = () => ({ type: MSEDCL_FEEDBACK_DETAILS_REQUEST });
export const msedclFeedbackDetailsSuccess = (data) => ({ type: MSEDCL_FEEDBACK_DETAILS_SUCCESS, payload: data });
export const msedclFeedbackDetailsFailure = (error) => ({ type: MSEDCL_FEEDBACK_DETAILS_FAILURE, payload: error });

export const msedclGetConsumerClosureFeedbackDetails = (serviceRequestId) => async (dispatch) => {
  dispatch(msedclFeedbackDetailsRequest());
  try {
    const payload = { service_request_id: String(serviceRequestId).trim() };
    const response = await axiosInstance.post(getMsedclConsumerClosureFeedbackDetails(), payload);
    const data = response?.data;
    const isSuccess = data?.status === "success" || data?.message_code === "75";
    if (!data || !isSuccess) {
      throw new Error(data?.message || "Failed to fetch feedback details");
    }
    dispatch(msedclFeedbackDetailsSuccess(data));
  } catch (error) {
    console.error("Error fetching consumer closure feedback details:", error);
    dispatch(
      msedclFeedbackDetailsFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Consumer Closure Submit Feedback ====================
export const MSEDCL_SUBMIT_FEEDBACK_REQUEST = "MSEDCL_SUBMIT_FEEDBACK_REQUEST";
export const MSEDCL_SUBMIT_FEEDBACK_SUCCESS = "MSEDCL_SUBMIT_FEEDBACK_SUCCESS";
export const MSEDCL_SUBMIT_FEEDBACK_FAILURE = "MSEDCL_SUBMIT_FEEDBACK_FAILURE";

export const msedclSubmitFeedbackRequest = () => ({ type: MSEDCL_SUBMIT_FEEDBACK_REQUEST });
export const msedclSubmitFeedbackSuccess = (data) => ({ type: MSEDCL_SUBMIT_FEEDBACK_SUCCESS, payload: data });
export const msedclSubmitFeedbackFailure = (error) => ({ type: MSEDCL_SUBMIT_FEEDBACK_FAILURE, payload: error });

export const msedclSubmitConsumerFeedback = (payload) => async (dispatch) => {
  dispatch(msedclSubmitFeedbackRequest());
  try {
    const body = {
      service_request_id: String(payload.service_request_id ?? "").trim(),
      consumer_resolution: payload.consumer_resolution ?? "",
      consumer_resolution_rating: payload.consumer_resolution === "Resolved" && payload.consumer_resolution_rating != null ? String(payload.consumer_resolution_rating) : null,
      consumer_unresolved_reason: payload.consumer_resolution === "Unresolved" && payload.consumer_unresolved_reason != null && payload.consumer_unresolved_reason !== "" ? String(payload.consumer_unresolved_reason) : null,
      source_of_request_id: payload.source_of_request_id ?? "30",
    };
    const response = await axiosInstance.post(getMsedclConsumerClosureSubmitFeedback(), body);
    const data = response?.data;
    const isSuccess = data?.status === "success" || data?.data?.message_code === "49";
    if (!data || !isSuccess) {
      throw new Error(data?.message || data?.data?.message || "Failed to submit feedback");
    }
    dispatch(msedclSubmitFeedbackSuccess(data));
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.response?.data?.data?.message || error.message || "Something went wrong";
    dispatch(msedclSubmitFeedbackFailure(message));
    throw error;
  }
};

// ==================== Change Address - District List ====================
export const MSEDCL_DISTRICT_LIST_REQUEST = "MSEDCL_DISTRICT_LIST_REQUEST";
export const MSEDCL_DISTRICT_LIST_SUCCESS = "MSEDCL_DISTRICT_LIST_SUCCESS";
export const MSEDCL_DISTRICT_LIST_FAILURE = "MSEDCL_DISTRICT_LIST_FAILURE";

export const msedclDistrictListRequest = () => ({ type: MSEDCL_DISTRICT_LIST_REQUEST });
export const msedclDistrictListSuccess = (data) => ({ type: MSEDCL_DISTRICT_LIST_SUCCESS, payload: data });
export const msedclDistrictListFailure = (error) => ({ type: MSEDCL_DISTRICT_LIST_FAILURE, payload: error });

export const msedclGetChangeAddressDistrictList = () => async (dispatch) => {
  dispatch(msedclDistrictListRequest());
  try {
    const response = await axiosInstance.get(getMsedclChangeAddressDistrictList());
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch district list");
    }
    dispatch(msedclDistrictListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching district list:", error);
    dispatch(
      msedclDistrictListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Change Address - Taluka List ====================
export const MSEDCL_TALUKA_LIST_REQUEST = "MSEDCL_TALUKA_LIST_REQUEST";
export const MSEDCL_TALUKA_LIST_SUCCESS = "MSEDCL_TALUKA_LIST_SUCCESS";
export const MSEDCL_TALUKA_LIST_FAILURE = "MSEDCL_TALUKA_LIST_FAILURE";

export const msedclTalukaListRequest = () => ({ type: MSEDCL_TALUKA_LIST_REQUEST });
export const msedclTalukaListSuccess = (data) => ({ type: MSEDCL_TALUKA_LIST_SUCCESS, payload: data });
export const msedclTalukaListFailure = (error) => ({ type: MSEDCL_TALUKA_LIST_FAILURE, payload: error });

export const msedclGetChangeAddressTalukaList = (districtLabel) => async (dispatch) => {
  dispatch(msedclTalukaListRequest());
  try {
    const response = await axiosInstance.post(getMsedclChangeAddressTalukaList(), { district: districtLabel });
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch taluka list");
    }
    dispatch(msedclTalukaListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching taluka list:", error);
    dispatch(
      msedclTalukaListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Change Address - Village List ====================
export const MSEDCL_VILLAGE_LIST_REQUEST = "MSEDCL_VILLAGE_LIST_REQUEST";
export const MSEDCL_VILLAGE_LIST_SUCCESS = "MSEDCL_VILLAGE_LIST_SUCCESS";
export const MSEDCL_VILLAGE_LIST_FAILURE = "MSEDCL_VILLAGE_LIST_FAILURE";

export const msedclVillageListRequest = () => ({ type: MSEDCL_VILLAGE_LIST_REQUEST });
export const msedclVillageListSuccess = (data) => ({ type: MSEDCL_VILLAGE_LIST_SUCCESS, payload: data });
export const msedclVillageListFailure = (error) => ({ type: MSEDCL_VILLAGE_LIST_FAILURE, payload: error });

export const msedclGetChangeAddressVillageList = (districtLabel, talukaLabel) => async (dispatch) => {
  dispatch(msedclVillageListRequest());
  try {
    const response = await axiosInstance.post(getMsedclChangeAddressVillageList(), {
      district: districtLabel,
      taluka: talukaLabel,
    });
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch village list");
    }
    dispatch(msedclVillageListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching village list:", error);
    dispatch(
      msedclVillageListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Change Address - Pincode List ====================
export const MSEDCL_PINCODE_LIST_REQUEST = "MSEDCL_PINCODE_LIST_REQUEST";
export const MSEDCL_PINCODE_LIST_SUCCESS = "MSEDCL_PINCODE_LIST_SUCCESS";
export const MSEDCL_PINCODE_LIST_FAILURE = "MSEDCL_PINCODE_LIST_FAILURE";

export const msedclPincodeListRequest = () => ({ type: MSEDCL_PINCODE_LIST_REQUEST });
export const msedclPincodeListSuccess = (data) => ({ type: MSEDCL_PINCODE_LIST_SUCCESS, payload: data });
export const msedclPincodeListFailure = (error) => ({ type: MSEDCL_PINCODE_LIST_FAILURE, payload: error });

export const msedclGetChangeAddressPincodeList = (districtLabel, talukaLabel) => async (dispatch) => {
  dispatch(msedclPincodeListRequest());
  try {
    const response = await axiosInstance.post(getMsedclChangeAddressPincodeList(), {
      district: districtLabel,
      taluka: talukaLabel,
    });
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch pincode list");
    }
    dispatch(msedclPincodeListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching pincode list:", error);
    dispatch(
      msedclPincodeListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Change Address - Submit ====================
export const MSEDCL_SUBMIT_ADDRESS_REQUEST = "MSEDCL_SUBMIT_ADDRESS_REQUEST";
export const MSEDCL_SUBMIT_ADDRESS_SUCCESS = "MSEDCL_SUBMIT_ADDRESS_SUCCESS";
export const MSEDCL_SUBMIT_ADDRESS_FAILURE = "MSEDCL_SUBMIT_ADDRESS_FAILURE";

export const msedclSubmitAddressRequest = () => ({ type: MSEDCL_SUBMIT_ADDRESS_REQUEST });
export const msedclSubmitAddressSuccess = (data) => ({ type: MSEDCL_SUBMIT_ADDRESS_SUCCESS, payload: data });
export const msedclSubmitAddressFailure = (error) => ({ type: MSEDCL_SUBMIT_ADDRESS_FAILURE, payload: error });

export const msedclSubmitChangeAddress = (payload) => async (dispatch) => {
  dispatch(msedclSubmitAddressRequest());
  try {
    const response = await axiosInstance.post(getMsedclChangeAddressSubmit(), payload);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to submit address");
    }
    dispatch(msedclSubmitAddressSuccess(response.data));
  } catch (error) {
    console.error("Error submitting address:", error);
    dispatch(
      msedclSubmitAddressFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

export const clearMsedclSubmitAddressData = () => ({ type: "CLEAR_MSEDCL_SUBMIT_ADDRESS_DATA" });

// ==================== Tariff - Activity Type List ====================
export const MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_REQUEST = "MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_REQUEST";
export const MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_SUCCESS = "MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_SUCCESS";
export const MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_FAILURE = "MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_FAILURE";

export const msedclTariffActivityTypeListRequest = () => ({ type: MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_REQUEST });
export const msedclTariffActivityTypeListSuccess = (data) => ({ type: MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_SUCCESS, payload: data });
export const msedclTariffActivityTypeListFailure = (error) => ({ type: MSEDCL_TARIFF_ACTIVITY_TYPE_LIST_FAILURE, payload: error });

export const msedclGetTariffActivityTypeList = (payload = {}) => async (dispatch) => {
  dispatch(msedclTariffActivityTypeListRequest());
  try {
    const body = payload.consumer_number != null ? { consumer_number: String(payload.consumer_number) } : {};
    const response = await axiosInstance.post(getMsedclTariffActivityTypeList(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch activity type list");
    }
    dispatch(msedclTariffActivityTypeListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching tariff activity type list:", error);
    dispatch(
      msedclTariffActivityTypeListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Tariff - Activity Group List ====================
export const MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_REQUEST = "MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_REQUEST";
export const MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_SUCCESS = "MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_SUCCESS";
export const MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_FAILURE = "MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_FAILURE";

export const msedclTariffActivityGroupListRequest = () => ({ type: MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_REQUEST });
export const msedclTariffActivityGroupListSuccess = (data) => ({ type: MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_SUCCESS, payload: data });
export const msedclTariffActivityGroupListFailure = (error) => ({ type: MSEDCL_TARIFF_ACTIVITY_GROUP_LIST_FAILURE, payload: error });

export const msedclGetTariffActivityGroupList = (payload = {}) => async (dispatch) => {
  dispatch(msedclTariffActivityGroupListRequest());
  try {
    const body = payload.activity_type != null ? { activity_type: String(payload.activity_type) } : {};
    const response = await axiosInstance.post(getMsedclTariffActivityGroupList(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch activity group list");
    }
    dispatch(msedclTariffActivityGroupListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching tariff activity group list:", error);
    dispatch(
      msedclTariffActivityGroupListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Tariff - Activity List ====================
export const MSEDCL_TARIFF_ACTIVITY_LIST_REQUEST = "MSEDCL_TARIFF_ACTIVITY_LIST_REQUEST";
export const MSEDCL_TARIFF_ACTIVITY_LIST_SUCCESS = "MSEDCL_TARIFF_ACTIVITY_LIST_SUCCESS";
export const MSEDCL_TARIFF_ACTIVITY_LIST_FAILURE = "MSEDCL_TARIFF_ACTIVITY_LIST_FAILURE";

export const msedclTariffActivityListRequest = () => ({ type: MSEDCL_TARIFF_ACTIVITY_LIST_REQUEST });
export const msedclTariffActivityListSuccess = (data) => ({ type: MSEDCL_TARIFF_ACTIVITY_LIST_SUCCESS, payload: data });
export const msedclTariffActivityListFailure = (error) => ({ type: MSEDCL_TARIFF_ACTIVITY_LIST_FAILURE, payload: error });

export const msedclGetTariffActivityList = (payload = {}) => async (dispatch) => {
  dispatch(msedclTariffActivityListRequest());
  try {
    const body = payload.activity_group != null ? { activity_group: String(payload.activity_group) } : {};
    const response = await axiosInstance.post(getMsedclTariffActivityList(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to fetch activity list");
    }
    dispatch(msedclTariffActivityListSuccess(response.data));
  } catch (error) {
    console.error("Error fetching tariff activity list:", error);
    dispatch(
      msedclTariffActivityListFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

// ==================== Tariff - Submit ====================
export const MSEDCL_SUBMIT_TARIFF_CHANGE_REQUEST = "MSEDCL_SUBMIT_TARIFF_CHANGE_REQUEST";
export const MSEDCL_SUBMIT_TARIFF_CHANGE_SUCCESS = "MSEDCL_SUBMIT_TARIFF_CHANGE_SUCCESS";
export const MSEDCL_SUBMIT_TARIFF_CHANGE_FAILURE = "MSEDCL_SUBMIT_TARIFF_CHANGE_FAILURE";

export const msedclSubmitTariffChangeRequest = () => ({ type: MSEDCL_SUBMIT_TARIFF_CHANGE_REQUEST });
export const msedclSubmitTariffChangeSuccess = (data) => ({ type: MSEDCL_SUBMIT_TARIFF_CHANGE_SUCCESS, payload: data });
export const msedclSubmitTariffChangeFailure = (error) => ({ type: MSEDCL_SUBMIT_TARIFF_CHANGE_FAILURE, payload: error });

export const msedclSubmitTariffChange = (payload) => async (dispatch) => {
  dispatch(msedclSubmitTariffChangeRequest());
  try {
    const body = {
      consumer_number: payload.consumer_number != null ? String(payload.consumer_number) : "",
      activity_type_id: payload.activity_type_id != null ? String(payload.activity_type_id) : "",
      activity_code: payload.activity_code != null ? String(payload.activity_code) : "",
      activity_group_id: payload.activity_group_id != null ? String(payload.activity_group_id) : "",
    };
    const response = await axiosInstance.post(getMsedclSubmitTariffChange(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response.data?.message || "Failed to submit tariff change");
    }
    dispatch(msedclSubmitTariffChangeSuccess(response.data));
  } catch (error) {
    console.error("Error submitting tariff change:", error);
    dispatch(
      msedclSubmitTariffChangeFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

export const clearMsedclSubmitTariffData = () => ({ type: "CLEAR_MSEDCL_SUBMIT_TARIFF_DATA" });

// ==================== Generate Aadhaar OTP (UIDAI) ====================
export const msedclGenerateAadhaarOtp = (payload) => async (dispatch) => {
  try {
    const body = { uid: payload.uid };
    const response = await axiosInstance.post(getMsedclGenerateAadhaarOtp(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to generate Aadhaar OTP");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Verify Aadhaar OTP (UIDAI) ====================
export const msedclVerifyAadhaarOtp = (payload) => async (dispatch) => {
  try {
    const body = {
      otp: payload.otp,
      uid: payload.uid,
      rc: payload.rc ?? "Y",
    };
    const response = await axiosInstance.post(getMsedclVerifyAadhaarOtp(), body);
    if (!response?.data || response.data.status !== "success") {
      const errMsg = response?.data?.data?.errorDesc || response?.data?.message || "Failed to verify Aadhaar OTP";
      throw new Error(errMsg);
    }
    const data = response.data?.data;
    if (data?.ret === "N" && data?.errorDesc) {
      throw new Error(data.errorDesc);
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.data?.errorDesc || error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Store Aadhaar UID (UIDAI) ====================
export const msedclStoreUid = (payload) => async (dispatch) => {
  try {
    const body = { uid: payload.uid };
    const response = await axiosInstance.post(getMsedclStoreUid(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to store Aadhaar UID");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Contact details update ====================
export const msedclContactDetailsUpdate = (payload) => async (dispatch) => {
  try {
    const body = {
      consumer_no: payload.consumer_no != null ? String(payload.consumer_no) : "",
      mobile_no: payload.mobile_no != null ? String(payload.mobile_no) : "",
      ref_num: payload.ref_num != null ? String(payload.ref_num) : "",
      aadhar_auth_flag: payload.aadhar_auth_flag != null ? String(payload.aadhar_auth_flag) : "Y",
    };
    const response = await axiosInstance.post(getMsedclContactDetailsUpdate(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to update contact details");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Get Consumer Name by Consumer No ====================
export const msedclGetConsumerNameByConsumerNo = (payload) => async (dispatch) => {
  try {
    const body = {
      consumer_no: payload.consumer_no != null ? String(payload.consumer_no) : "",
    };
    const response = await axiosInstance.post(getMsedclConsumerNameByConsumerNo(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch consumer details");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Change of Name Reason List ====================
export const msedclGetChangeOfNameReasonList = (payload) => async (dispatch) => {
  try {
    const body = { consumer_number: payload.consumer_number };
    const response = await axiosInstance.post(getMsedclChangeOfNameReasonList(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch reason list");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Submit Change of Name ====================
export const msedclSubmitChangeOfName = (payload) => async (dispatch) => {
  try {
    const body = {
      consumer_number: payload.consumer_number,
      aadhar_vault_ref_no: payload.aadhar_vault_ref_no,
      change_of_name_reason_id: payload.change_of_name_reason_id,
      eng_first_name: payload.eng_first_name,
      eng_middle_name: payload.eng_middle_name,
      eng_last_name: payload.eng_last_name,
    };
    if (payload.registred_mob_no !== undefined) {
      body.registred_mob_no = payload.registred_mob_no;
    }
    if (payload.documents_upload !== undefined) {
      body.documents_upload = Boolean(payload.documents_upload);
    }
    if (payload.application_id !== undefined && payload.application_id !== null) {
      body.application_id = String(payload.application_id);
    }
    if (Array.isArray(payload.documents)) {
      body.documents = payload.documents;
    }
    const response = await axiosInstance.post(getMsedclSubmitChangeOfName(), body);
    if (!response?.data || response.data.status !== "success") {
      throw new Error(response?.data?.message || "Failed to submit change of name");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Get Salary Slip ====================
export const MSEDCL_GET_SALARY_SLIP_REQUEST = "MSEDCL_GET_SALARY_SLIP_REQUEST";
export const MSEDCL_GET_SALARY_SLIP_SUCCESS = "MSEDCL_GET_SALARY_SLIP_SUCCESS";
export const MSEDCL_GET_SALARY_SLIP_FAILURE = "MSEDCL_GET_SALARY_SLIP_FAILURE";

export const msedclGetSalarySlipRequest = () => ({ type: MSEDCL_GET_SALARY_SLIP_REQUEST });
export const msedclGetSalarySlipSuccess = (data) => ({ type: MSEDCL_GET_SALARY_SLIP_SUCCESS, payload: data });
export const msedclGetSalarySlipFailure = (error) => ({ type: MSEDCL_GET_SALARY_SLIP_FAILURE, payload: error });

export const msedclGetSalarySlip = (month, year) => async (dispatch) => {
  dispatch(msedclGetSalarySlipRequest());
  try {
    const payload = {
      month: String(month),
      year: String(year),
    };
    const response = await axiosInstance.post(getMsedclGetSalarySlip(), payload);
    if (!response?.data) throw new Error("No salary slip data received.");
    dispatch(msedclGetSalarySlipSuccess(response.data));
  } catch (error) {
    console.error("Get salary slip error:", error);
    dispatch(
      msedclGetSalarySlipFailure(
        error.response?.data?.message || error.message || "Something went wrong"
      )
    );
  }
};

export const clearMsedclSalarySlipData = () => ({ type: "CLEAR_MSEDCL_SALARY_SLIP_DATA" });

// ==================== Biometric Attendance ====================
export const msedclGetBiometricAttendance = ({ cpfno, ym }) => async () => {
  try {
    const url = getMsedclGetBiometricAttendance({ cpfno, ym });
    const response = await axiosInstance.get(url, {
      headers: { Accept: "application/json" },
    });
    if (!response?.data || String(response.data.status || "").toLowerCase() !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch biometric attendance");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Flag Day / Fund Contribution ====================
export const msedclGetFundContributionDetail = ({ eno }) => async () => {
  try {
    const url = getMsedclFundContributionDetail({ eno });
    const response = await axiosInstance.get(url, {
      headers: { "Accept-Language": "EN" },
    });
    if (!response?.data || String(response.data.status || "").toLowerCase() !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch fund contribution details");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const msedclGetFundContributionMasterData = () => async () => {
  try {
    const url = getMsedclFundContributionMasterData();
    const response = await axiosInstance.get(url, {
      headers: { "Accept-Language": "EN" },
    });
    if (!response?.data || String(response.data.status || "").toLowerCase() !== "success") {
      throw new Error(response?.data?.message || "Failed to fetch fund contribution master data");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

export const msedclSaveFundContributionDetail = (payload) => async () => {
  try {
    const url = getMsedclSaveFundContributionDetail();
    const body = {
      cpfNo: String(payload?.cpfNo ?? "").trim(),
      recoveryMonth: String(payload?.recoveryMonth ?? "").trim(),
      recoveryAmount: String(payload?.recoveryAmount ?? "").trim(),
      eventName: String(payload?.eventName ?? "").trim(),
      description: String(payload?.description ?? "").trim(),
      locatonId: String(payload?.locatonId ?? "").trim(),
      optionValue: String(payload?.optionValue ?? "").trim(),
    };
    const response = await axiosInstance.post(url, body, {
      headers: {
        Accept: "application/json",
        "Accept-Language": "EN",
      },
    });
    if (!response?.data || String(response.data.status || "").toLowerCase() !== "success") {
      throw new Error(response?.data?.message || "Failed to save fund contribution detail");
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(message);
  }
};

// ==================== Get Employee Details By Mobile (Update Profile) ====================
export const MSEDCL_GET_EMPLOYEE_DETAILS_REQUEST = "MSEDCL_GET_EMPLOYEE_DETAILS_REQUEST";
export const MSEDCL_GET_EMPLOYEE_DETAILS_SUCCESS = "MSEDCL_GET_EMPLOYEE_DETAILS_SUCCESS";
export const MSEDCL_GET_EMPLOYEE_DETAILS_FAILURE = "MSEDCL_GET_EMPLOYEE_DETAILS_FAILURE";

export const msedclGetEmployeeDetailsRequest = () => ({ type: MSEDCL_GET_EMPLOYEE_DETAILS_REQUEST });
export const msedclGetEmployeeDetailsSuccess = (data) => ({ type: MSEDCL_GET_EMPLOYEE_DETAILS_SUCCESS, payload: data });
export const msedclGetEmployeeDetailsFailure = (error) => ({ type: MSEDCL_GET_EMPLOYEE_DETAILS_FAILURE, payload: error });

export const msedclGetEmployeeDetailsByMobile = (mobile) => async (dispatch) => {
  dispatch(msedclGetEmployeeDetailsRequest());
  try {
    const response = await axiosInstance.get(getMsedclGetEmployeeDetailsByMobile());
    const data = response?.data?.employee_details ?? response?.data?.data ?? response?.data;
    if (!data) throw new Error("No employee details received.");
    dispatch(msedclGetEmployeeDetailsSuccess(data));
    return data;
  } catch (error) {
    const errMsg = error.response?.data?.message || error.message || "Something went wrong";
    dispatch(msedclGetEmployeeDetailsFailure(errMsg));
    throw new Error(errMsg);
  }
};

export const clearMsedclEmployeeDetailsData = () => ({ type: "CLEAR_MSEDCL_EMPLOYEE_DETAILS_DATA" });

// ==================== Leave Type List (Leave Application) — from develop ====================
export const msedclGetLeaveTypeList = (params) => async (dispatch) => {
  try {
    const url = getMsedclLeaveTypeList();
    const response = await axiosInstance.get(url, { params: params || {} });
    const data = response?.data?.data ?? response?.data;
    if (!Array.isArray(data)) return [];
    return data;
  } catch (error) {
    console.error("Error fetching leave type list:", error);
    return [];
  }
};

// ==================== Leave Balance (Leave Application) ====================
export const msedclGetLeaveBalance = (payload) => async (dispatch) => {
  try {
    const url = getMsedclLeaveBalance();
    const response = await axiosInstance.post(url, payload);
    const data = response?.data?.data ?? response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching leave balance:", error);
    return null;
  }
};

// ==================== Leave Code Balance List (Show Leaves) ====================
export const msedclGetLeaveCodeBalance = (params) => async (dispatch) => {
  try {
    const url = getMsedclLeaveCodeBalance();
    const response = await axiosInstance.get(url, { params: params || {} });
    const data = response?.data?.data ?? response?.data;
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error fetching leave code balance list:", error);
    return [];
  }
};

// ==================== Leave Application Details / Authorities ====================
export const msedclGetLeaveApplicationDetails = (payload) => async (dispatch) => {
  try {
    const url = getMsedclLeaveApplicationSubmit();
    const response = await axiosInstance.get(url, { params: payload || {} });
    const data = response?.data?.data ?? response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching leave application details:", error);
    return null;
  }
};

// ==================== Save Leave Application ====================
export const msedclLeaveApplicationSave = (payload) => async (dispatch) => {
  try {
    const url = getMsedclLeaveApplicationSave();
    const response = await axiosInstance.post(url, payload);
    const data = response?.data;
    if (data?.status === "success" || data?.status === "SUCCESS" || data?.status === 200 || data?.success || data?.status_code === 200) {
      return data;
    }
    throw new Error(data?.message || "Failed to save leave application");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error saving leave application:", error);
    throw new Error(message);
  }
};

// ==================== Get Leave LTC Block Year ====================
export const msedclGetLtcBlockYear = () => async (dispatch) => {
  try {
    const url = getMsedclLtcBlockYear();
    const response = await axiosInstance.get(url);
    const data = response?.data?.data ?? response?.data;
    if (!Array.isArray(data)) return [];
    return data;
  } catch (error) {
    console.error("Error fetching LTC block years:", error);
    return [];
  }
};

// ==================== Get Leave Disability Types ====================
export const msedclGetLeaveDisabilityTypes = () => async (dispatch) => {
  try {
    const url = getMsedclLeaveDisabilityTypes();
    const response = await axiosInstance.get(url);
    const data = response?.data;
    const list = data?.data || data?.disability_types || data?.result || data || [];
    return Array.isArray(list) ? list : [];
  } catch (error) {
    console.error("Error fetching disability types:", error);
    return [];
  }
};

// ==================== Leave Application List ====================
export const msedclGetLeaveApplicationList = (payload) => async (dispatch) => {
  try {
    const url = getMsedclLeaveApplicationList(payload.employee_number || payload.employeeNumber);
    const response = await axiosInstance.get(url, { params: payload || {} });
    const data = response?.data?.data ?? response?.data;
    if (!Array.isArray(data)) return [];
    return data;
  } catch (error) {
    console.error("Error fetching leave application list:", error);
    return [];
  }
};

// ==================== Check Overlapping Claims (Mobile Bills etc.) ====================
export const msedclCheckOverlappingClaims = (payload) => async (dispatch) => {
  try {
    const url = getMsedclCheckOverlappingClaims();
    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error checking overlapping claims:", error);
    throw new Error(message);
  }
};

// ==================== Check Overlapping Savings (Tax Regime) ====================
export const msedclCheckOverlappingSavings = (payload) => async (dispatch) => {
  try {
    const url = getMsedclCheckOverlappingSavings();
    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error checking overlapping savings:", error);
    throw new Error(message);
  }
};

// ==================== Submit Claim Application (Mobile Bills etc.) ====================
export const msedclSubmitClaimApplication = (payload) => async (dispatch) => {
  try {
    const url = getMsedclSubmitClaimApplication();
    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error submitting claim application:", error);
    throw new Error(message);
  }
};

// ==================== Mobile limit (annual limit + claimed amount) ====================
export const msedclGetMobileLimit = (params) => async (dispatch) => {
  try {
    const url = getMsedclMobileLimit(params || {});
    const response = await axiosInstance.get(url);
    return response?.data?.data ?? response?.data ?? null;
  } catch (error) {
    console.error("Error fetching mobile limit:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch mobile limit");
  }
};

// ==================== Claim Application List (ViewClaims) ====================
export const msedclGetClaimApplicationList = (payload) => async (dispatch) => {
  try {
    const url = getMsedclClaimApplicationList();
    const response = await axiosInstance.post(url, payload || {});
    const raw = response?.data?.data ?? response?.data;
    return Array.isArray(raw) ? raw : [];
  } catch (error) {
    console.error("Error fetching claim application list:", error);
    return [];
  }
};

// ==================== New Claim Application (get one for view/edit) ====================
export const msedclGetNewClaimApplication = (payload) => async (dispatch) => {
  try {
    const url = getMsedclNewClaimApplication();
    const response = await axiosInstance.post(url, payload || {});
    const raw = response?.data;
    if (String(raw?.status || "").toLowerCase() === "failed") {
      return raw;
    }
    return raw?.data ?? raw;
  } catch (error) {
    console.error("Error fetching new claim application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to load claim.");
  }
};

// ==================== View Claim Application (for view/update from list) ====================
export const msedclGetViewClaimApplication = (payload) => async (dispatch) => {
  try {
    const url = getMsedclViewClaimApplication();
    const response = await axiosInstance.post(url, payload || {});
    return response?.data?.data ?? response?.data;
  } catch (error) {
    console.error("Error fetching view claim application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to load claim.");
  }
};

// ==================== Extra CPF Application ====================
export const msedclGetNewExtraCpfApplication = (eno) => async (dispatch) => {
  try {
    const url = getMsedclNewExtraCpfApplication(eno);
    const response = await axiosInstance.get(url);
    const data = response?.data?.data ?? response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching new extra cpf application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to load extra CPF application.");
  }
};

export const msedclSaveExtraCpfApplication = (payload) => async (dispatch) => {
  try {
    const url = getMsedclSaveExtraCpfApplication();
    const response = await axiosInstance.post(url, payload || {});
    return response?.data ?? null;
  } catch (error) {
    console.error("Error saving extra cpf application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to save extra CPF application.");
  }
};

// ==================== Extra CPF Application List (ViewTaxRegime) ====================
export const msedclGetExtraCpfApplicationList = (eno) => async () => {
  try {
    const url = getMsedclExtraCpfApplicationList(eno);
    const response = await axiosInstance.get(url);
    const data = response?.data?.data ?? response?.data ?? {};
    const list =
      data?.extra_cpf_application_list ||
      data?.extraCpfApplicationList ||
      data?.list ||
      data?.records ||
      data?.items ||
      (Array.isArray(data) ? data : []);
    return Array.isArray(list) ? list : [];
  } catch (error) {
    console.error("Error fetching extra cpf application list:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch extra CPF application list.");
  }
};

// ==================== Tax Regime Application ====================
export const msedclGetNewRegimeApplication = () => async (dispatch) => {
  try {
    const url = getMsedclNewRegimeApplication();
    const response = await axiosInstance.get(url);
    const data = response?.data?.data ?? response?.data;
    return data;
  } catch (error) {
    console.error("Error fetching new regime application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to load regime application.");
  }
};

export const msedclSaveRegimeApplication = (payload) => async (dispatch) => {
  try {
    const url = getMsedclSaveRegimeApplication();
    const response = await axiosInstance.post(url, payload || {});
    return response?.data ?? null;
  } catch (error) {
    console.error("Error saving regime application:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to save regime application.");
  }
};

// ==================== Claim File Options (Taltc etc.) ====================
export const msedclGetClaimFileOptions = (claimType) => async (dispatch) => {
  try {
    const url = getMsedclClaimFileOptions(claimType);
    const response = await axiosInstance.get(url);
    const raw = response?.data?.data ?? response?.data;
    const list = Array.isArray(raw) ? raw : [];
    return list.map((item) => ({
      value: item.value ?? item.code ?? item.id ?? item.fileTypeCode ?? item.file_type_code ?? "",
      label: item.label ?? item.name ?? item.description ?? item.fileTypeName ?? item.file_type_name ?? String(item.value ?? item.code ?? item.id ?? ""),
    })).filter((o) => o.value !== "" && o.value != null);
  } catch (error) {
    console.error("Error fetching claim file options:", error);
    return [];
  }
};

// ==================== Claim Class Options (journey class by transport mode) ====================
export const msedclGetClaimClassOptions = (transportMode) => async (dispatch) => {
  try {
    const url = getMsedclClaimClassOptions(transportMode);
    const response = await axiosInstance.get(url);
    const raw = response?.data?.data ?? response?.data;
    const list = Array.isArray(raw) ? raw : [];
    return list
      .map((item) => {
        const value = item?.value ?? item?.code ?? item?.id ?? item?.classCode ?? item?.class_code ?? item?.name ?? "";
        const label = item?.label ?? item?.name ?? item?.description ?? item?.className ?? item?.class_name ?? String(value ?? "");
        return { value, label };
      })
      .filter((o) => o.value !== "" && o.value != null);
  } catch (error) {
    console.error("Error fetching claim class options:", error);
    return [];
  }
};

// ==================== DA Types / Rate (Taltc) ====================
export const msedclGetDaTypes = () => async (dispatch) => {
  try {
    const url = getMsedclDaTypes();
    const response = await axiosInstance.get(url);
    const raw = response?.data?.data ?? response?.data ?? [];
    return Array.isArray(raw) ? raw : [];
  } catch (error) {
    console.error("Error fetching DA types:", error);
    return [];
  }
};

export const msedclGetDaRate = (params = {}) => async (dispatch) => {
  try {
    const url = getMsedclDaRate(params);
    const response = await axiosInstance.get(url);
    return response?.data?.data ?? response?.data ?? null;
  } catch (error) {
    console.error("Error fetching DA rate:", error);
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch DA rate");
  }
};

// ==================== Time Slot Options (OtBills) ====================
export const msedclGetTimeSlotOptions = () => async (dispatch) => {
  try {
    const url = getMsedclTimeSlotOptions();
    const response = await axiosInstance.get(url);
    const raw = response?.data?.data ?? response?.data ?? [];
    return Array.isArray(raw) ? raw : [];
  } catch (error) {
    console.error("Error fetching time slot options:", error);
    return [];
  }
};

// ==================== Submit Claim Passenger Details (OtBills) ====================
export const msedclSubmitClaimPassengerDetails = (payload) => async (dispatch) => {
  try {
    const url = getMsedclSaveClaimPassengerDetails();
    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error submitting claim passenger details:", error);
    throw new Error(message);
  }
};

// ==================== Employee portal file upload (Leaves / Claims) ====================
export const msedclEmployeePortalFileUpload = (formData) => async (dispatch) => {
  try {
    const url = getMsedclEmployeePortalFileUpload();
    const response = await axiosInstance.post(url, formData);
    const data = response?.data;
    if (data?.status === "success" || data?.status === "SUCCESS" || data?.status === 200 || data?.success || data?.status_code === 200) {
      return data;
    }
    throw new Error(data?.message || "Failed to upload file");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error uploading file:", error);
    throw new Error(message);
  }
};

// ==================== Employee portal file list (Claims / Leaves by applId) ====================
export const msedclGetEmployeePortalFileList = (params) => async (dispatch) => {
  try {
    const url = getMsedclEmployeePortalFileList();
    const applId = String(params?.applId ?? params?.application_id ?? "").trim();
    const fileCategory = String(params?.fileCategory ?? params?.file_category ?? "Claims").trim();
    const response = await axiosInstance.get(url, {
      params: { applId, fileCategory },
    });
    const root = response?.data;
    const inner = root?.data ?? root;
    if (Array.isArray(inner)) return inner;
    if (Array.isArray(inner?.files)) return inner.files;
    if (Array.isArray(inner?.file_list)) return inner.file_list;
    if (Array.isArray(inner?.data)) return inner.data;
    if (root?.status === "success" || root?.status === "SUCCESS" || root?.success) {
      return Array.isArray(inner) ? inner : [];
    }
    throw new Error(root?.message || "Failed to load file list");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error fetching employee portal file list:", error);
    throw new Error(message);
  }
};

// ==================== Employee portal file delete ====================
export const msedclEmployeePortalFileDelete = (payload) => async (dispatch) => {
  try {
    const url = getMsedclEmployeePortalFileDelete();
    const body = {
      application_id: String(payload?.application_id ?? ""),
      f_id: String(payload?.f_id ?? ""),
      file_category: String(payload?.file_category ?? ""),
    };
    const response = await axiosInstance.post(url, body);
    const data = response?.data;
    if (data?.status === "success" || data?.status === "SUCCESS" || data?.status === 200 || data?.success || data?.status_code === 200) {
      return data;
    }
    throw new Error(data?.message || "Failed to delete file");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error deleting employee portal file:", error);
    throw new Error(message);
  }
};

// ==================== Employee portal file download ====================
export const msedclEmployeePortalFileDownload = (payload) => async (dispatch) => {
  try {
    const url = getMsedclEmployeePortalFileDownload();
    const applId = String(payload?.applId ?? payload?.application_id ?? "").trim();
    const fileCategory = String(payload?.fileCategory ?? payload?.file_category ?? "Claims").trim();
    const fId = String(payload?.fId ?? payload?.f_id ?? payload?.fileId ?? payload?.id ?? "").trim();
    if (!applId || !fId) throw new Error("applId and fId are required for download.");
    const response = await axiosInstance.get(url, {
      params: { applId, fId, fileCategory },
      responseType: "blob",
    });
    const cd = response?.headers?.["content-disposition"] || "";
    const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(String(cd));
    const fileName = decodeURIComponent(match?.[1] || match?.[2] || "");
    return { blob: response?.data, fileName };
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error downloading employee portal file:", error);
    throw new Error(message);
  }
};

export const msedclUpdateProfile = (payload) => async (dispatch) => {
  try {
    const url = getMsedclUpdateProfile();
    const response = await axiosInstance.post(url, payload);
    const data = response?.data;
    if (data?.status === "success" || data?.status === "SUCCESS" || data?.status === 200 || data?.success || data?.status_code === 200) {
      return data;
    }
    throw new Error(data?.message || "Failed to update profile");
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    console.error("Error updating profile:", error);
    throw new Error(message);
  }
};

